export default __webpack_public_path__ + "static/media/setion01_kv01.965b57b6.png";